export default __webpack_public_path__ + "static/media/30.41cf03ea.jpg";